/* RO 4.0: diskrete scroll-reveals + scroll-tegnet traad.
   Haandterer Shopify theme-editorens section-reload-events, saa indhold
   ikke forbliver skjult efter en setting-aendring i customizeren. */
(function () {
	var hasIO = 'IntersectionObserver' in window;
	var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	/* Progressive enhancement: skjule-/animations-regler i raw40.css er gated
	   paa html.raw40-js — klassen saettes KUN her, og KUN naar IO findes.
	   Fejler scriptet (netvaerk/blocker) eller mangler IO, forbliver alt
	   indhold synligt uden animation. */
	if (hasIO) {
		document.documentElement.classList.add('raw40-js');
	}

	/* ---------- reveals ---------- */
	var io = null;
	if (hasIO) {
		io = new IntersectionObserver(function (entries) {
			entries.forEach(function (e) {
				if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
			});
		}, { rootMargin: '0px 0px -8% 0px' });
	}
	function observeReveals() {
		if (!io) {
			document.documentElement.classList.add('no-raw40-io');
			return;
		}
		document.querySelectorAll('.raw40-reveal:not(.is-in), .raw40-belt:not(.is-in)').forEach(function (el) { io.observe(el); });
	}

	/* ---------- scroll-tegnet traad ---------- */
	var threads = [];
	var threadListenersBound = false;
	function collectThreads() {
		threads = Array.prototype.slice.call(document.querySelectorAll('[data-raw40-thread]'));
		if (!reduced) {
			threads.forEach(function (el) { el.classList.add('is-armed'); });
		}
	}
	function updateThreads() {
		var vh = window.innerHeight || document.documentElement.clientHeight;
		threads.forEach(function (el) {
			if (!el.isConnected) return;
			var r = el.getBoundingClientRect();
			var start = vh * 0.85;
			var end = vh * 0.45;
			var progress = (start - r.top) / (r.height + (start - end));
			progress = Math.max(0, Math.min(1, progress));
			el.style.setProperty('--draw', progress.toFixed(3));
		});
	}
	var ticking = false;
	function onScroll() {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(function () { updateThreads(); updateParallax(); ticking = false; });
	}
	function bindThreadListeners() {
		if (threadListenersBound || reduced) return;
		threadListenersBound = true;
		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll, { passive: true });
	}

	/* ---------- diskret parallax ([data-raw40-parallax="px"]) ---------- */
	var parallaxEls = [];
	function collectParallax() {
		parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-raw40-parallax]'));
	}
	function updateParallax() {
		if (reduced) return;
		var vh = window.innerHeight || document.documentElement.clientHeight;
		parallaxEls.forEach(function (el) {
			if (!el.isConnected) return;
			var amp = parseFloat(el.getAttribute('data-raw40-parallax')) || 0;
			var r = el.getBoundingClientRect();
			var center = r.top + r.height / 2;
			var progress = Math.max(-1, Math.min(1, (center - vh / 2) / (vh / 2)));
			el.style.setProperty('--raw40-parallax', (progress * amp).toFixed(1) + 'px');
		});
	}

	/* ---------- lazy video (spiller foerst naar den er i viewport) ---------- */
	function observeVideos() {
		document.querySelectorAll('video[data-raw40-lazy]:not([data-raw40-armed])').forEach(function (v) {
			v.setAttribute('data-raw40-armed', '1');
			if (!hasIO) { v.play().catch(function () {}); return; }
			var vio = new IntersectionObserver(function (entries) {
				entries.forEach(function (e) {
					if (e.isIntersecting) { e.target.play().catch(function () {}); }
					else { e.target.pause(); }
				});
			}, { rootMargin: '120px 0px' });
			vio.observe(v);
		});
	}

	/* ---------- init + Shopify editor-events ---------- */
	function initAll() {
		observeReveals();
		collectThreads();
		collectParallax();
		if (threads.length || parallaxEls.length) {
			bindThreadListeners();
			updateThreads();
			updateParallax();
		}
		observeVideos();
		var activePill = document.querySelector('.raw40-goals__pill.is-active');
		if (activePill && window.innerWidth < 760 && activePill.scrollIntoView) {
			activePill.scrollIntoView({ inline: 'center', block: 'nearest' });
		}
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}
	document.addEventListener('shopify:section:load', initAll);
	document.addEventListener('shopify:section:unload', function () { collectThreads(); collectParallax(); });
})();
